export const flattenMessages = <TranslationKey extends string>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  nestedMessages: any,
  prefix = "",
): Record<TranslationKey, string> => {
  if (nestedMessages === null) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {} as any;
  }
  return Object.keys(nestedMessages).reduce((messages, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === "string") {
      Object.assign(messages, { [prefixedKey]: value });
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any);
};
